var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLounge = function SvgLounge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    style: {
      animationPlayState: "paused",
      backgroundAttachment: "initial",
      backgroundClip: "initial",
      backgroundColor: "transparent",
      backgroundImage: "initial",
      backgroundOrigin: "initial",
      backgroundPositionX: "initial",
      backgroundPositionY: "initial",
      backgroundRepeatX: "initial",
      backgroundRepeatY: "initial",
      backgroundSize: "initial",
      height: "100%",
      width: "100%"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      animationPlayState: "paused",
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#8c1524",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 18.2,
    x2: 18.2,
    y1: 69.5,
    y2: 78.7,
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.8,
    x2: 81.8,
    y1: 69.5,
    y2: 78.7,
    style: {
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#8c1524",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8,54.7H22.2V25.1c0-2.1,1.7-3.8,3.8-3.8h48c2.1,0,3.8,1.7,3.8,3.8V54.7z",
    fill: "#ff8892",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.8 54.7h-55.6v-6.6c0-2 1.6-3.6 3.6-3.6h48.4c2 0 3.6 1.6 3.6 3.6v6.6z",
    fill: "#ff5151",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,54.7H77.8V36.5c0-1.9,1.5-3.4,3.4-3.4h5.3c1.9,0,3.4,1.5,3.4,3.4V54.7z",
    fill: "#ff5151",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,54.7h12.2V36.5c0-1.9-1.5-3.4-3.4-3.4h-5.3c-1.9,0-3.4,1.5-3.4,3.4V54.7z",
    fill: "#ff5151",
    style: {
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 54.7,
    width: 80,
    height: 14.8,
    fill: "#ff6969",
    stroke: "#8c1524",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("metadata", {
    style: {
      animationPlayState: "paused"
    },
    xmlnsD: "https://loading.io/stock/"
  }, /*#__PURE__*/React.createElement("dName", {
    style: {
      animationPlayState: "paused"
    }
  }, "lounge"), /*#__PURE__*/React.createElement("dTags", {
    style: {
      animationPlayState: "paused"
    }
  }, "chair,couch,sofa,living room,settee,bench"), /*#__PURE__*/React.createElement("dLicense", {
    style: {
      animationPlayState: "paused"
    }
  }, "by"), /*#__PURE__*/React.createElement("dSlug", {
    style: {
      animationPlayState: "paused"
    }
  }, "4ysc8g"))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLounge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lounge.f786d7c37a3eca7d71af658be86120dd.svg";